// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"169":"3882338f","185":"28f5c21d","820":"ceb62b8d"}[chunkId] + ".chunk.css";
};